import React from "react";
import { inject, observer } from "mobx-react";
import Alert from "react-bootstrap/Alert";

function FlashMsg({ GlobalStore: { msg } }) {
  return msg ? <Alert variant="warning">{msg}</Alert> : null;
}

export default inject("GlobalStore")(observer(FlashMsg));
